import React from 'react';
import { CloudArrowUp } from '@phosphor-icons/react';
import { Upload } from 'antd';
import type { RcFile } from 'antd/es/upload/interface';

import { isMobile, isTablet } from 'react-device-detect';

interface Props {
  type: 'photo' | 'video';
  onDrop: (file: RcFile) => void;
}

const DemoUploader: React.FC<Props> = (props) => {
  const { type, onDrop } = props;

  const draggerProps =
    type === 'photo'
      ? { accept: '.bmp,.gif,.jpeg,.jpg,.png', maxCount: 1, multiple: false }
      : { accept: '.mov,.mp4', multiple: true };

  const text = type === 'photo' ? 'Your photo' : 'Your videos';

  return (
    <Upload.Dragger
      {...draggerProps}
      showUploadList={false}
      beforeUpload={(file) => {
        onDrop(file);
        return false;
      }}
      className="w-full sm:w-2/3 h-48 sm:h-64 lg:h-96 rounded-md shadow-xl transition-all hover:bg-grey-100"
    >
      <div className="flex items-center justify-center gap-4 px-4 text-base text-left">
        <CloudArrowUp
          className="fill-[url('#icon-primary-gradient')] group-hover:animate-pulsing"
          size={100}
        />

        <div>
          <div className="font-bold">{text}</div>

          <div>
            {isMobile || isTablet
              ? 'Click to upload'
              : 'Drag and drop or click to upload'}
          </div>
        </div>
      </div>
    </Upload.Dragger>
  );
};

export default DemoUploader;
